import React from 'react';

import Fallback from 'v3/components/Fallback';
import Text from 'v3/components/Text';

import * as Styled from './styles';
import { AttachmentComponent } from './attachment';

export function DocumentType({
  title,
  documents,
  onClickPreview,
  fetchDocuments,
  emittedId,
  setLoading,
}) {
  const filteredAttachments = documents.filter(
    (document) => document.attachments[0].status === 'accept',
  );
  return (
    <div className="text-center mt-4">
      <Text as="div" type="regular" color="dark" weight={500}>
        {title}
      </Text>
      <div>
        <Styled.ImageRow>
          <Fallback
            fall={filteredAttachments.length === 0}
            component={
              <div className="text-center flex-fill">
                <Text color="gray">Nenhuma imagem enviada.</Text>
              </div>
            }
          >
            {filteredAttachments.map((document) => (
              <AttachmentComponent
                key={document.id}
                document={document}
                onClickPreview={() => onClickPreview(document.id)}
                fetchDocuments={fetchDocuments}
                emittedId={emittedId}
                setLoading={setLoading}
              />
            ))}
          </Fallback>
        </Styled.ImageRow>
      </div>
    </div>
  );
}
